import { useMemo } from 'react';
import { TOWPRO } from '@rsos/capstone/src/constants/capabilities';
import { TOWPRO_PERMISSION } from '@rsos/constants/permissions';
import { useFlag } from '@rsos/flags';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';

/** Development flag that bypasses the capability and permission gates. */
export const TOWPRO_FORCE_ENABLED_FLAG = 'towpro_force_enabled';

const useHasAccessToTowPro = (): boolean => {
  const isForceEnabled = useFlag(TOWPRO_FORCE_ENABLED_FLAG);
  const hasTowProCapability = useHasCapability(TOWPRO);
  const hasTowProPermission = useHasPermission(TOWPRO_PERMISSION);

  return useMemo(() => {
    if (isForceEnabled) {
      return true;
    }
    return (
      !!hasTowProCapability?.hasCapability &&
      !!hasTowProPermission?.hasPermission
    );
  }, [isForceEnabled, hasTowProCapability, hasTowProPermission]);
};

export default useHasAccessToTowPro;
